import { createI18nText } from '@hilma/netina2all';

const generalText = createI18nText({
	he: {
		showMore: 'קרא עוד',
		showLess: 'קרא פחות',
		search: 'חיפוש'
	},
	en: {
		showMore: 'Show more',
		showLess: 'Show less',
		search: 'search'
	}
});

export default generalText;